export const getPlanName = (priceId) => {
  const nameMap = {
    [process.env.NEXT_PUBLIC_MINIMUM_PRICE_ID]: 'ミニマムプラン',
    [process.env.NEXT_PUBLIC_MEDIUM_PRICE_ID]: 'ノーマルプラン',
    [process.env.NEXT_PUBLIC_PREMIUM_PRICE_ID]: 'エンタープライズプラン',
  }
  return nameMap[priceId]
}